import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home';

export default function LatestArticles() {
  return (
    <section id="latest-articles" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            最新推荐文章
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            深度解析热门韩漫作品，分享阅读心得与推荐指南
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.cover}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.author}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/#categories"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 text-sm font-medium rounded-full border border-primary-300 text-primary-600 whitespace-nowrap hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
          >
            浏览更多文章
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}